// Bileli · i18n — Kyrgyz for the TEACHER (teach) module: cabinet, editors, cohorts, publish, quiz builder.
// Keyed by the exact Russian source string (see index.ts). Identical-in-Kyrgyz strings are deliberately
// OMITTED (t() falls back to the key): Тест, сом, ＋ Модуль, ＋ Вариант, Вариант {n},
// ＋ Видео-превью, Видео / Текст / PDF / Тест type labels (icons live in code). Strings already translated in
// ky.common / ky.learn (сохраняю…, Загрузка…, ошибка, Очистить, Готово, Открыть, ← К курсу,
// Не удалось загрузить курс/урок., Не удалось сохранить имя., Не удалось отправить ответ., Создаём…,
// ← Назад к курсам, Входим в Bileli…, Программа курса, Преподаватель, Ученик, преподаватель, Ответить,
// Все, Бесплатно, Удалить) are not repeated here.
export const KY_TEACH: Record<string, string> = {
  // Earnings & payouts (modules/earnings — EarningsView + PayoutDestinationPanel). «{n} сом» / «Комиссия»
  // are identical in Kyrgyz → omitted; «Сохраняем…» is already in ky.learn (t() falls back through the merge).
  Доходы: 'Кирешелер',
  'Доходы появятся здесь': 'Кирешелер бул жерде көрүнөт',
  'Как только студенты начнут оплачивать ваши курсы, здесь появятся начисления и выплаты.':
    'Студенттер курстарыңызды төлөй баштаганда, бул жерде чегерүүлөр менен төлөмдөр көрүнөт.',
  'Доступно к выплате': 'Төлөөгө жеткиликтүү',
  'На удержании': 'Кармалууда',
  Заблокировано: 'Бөгөттөлгөн',
  Выплачено: 'Төлөндү',
  'Средства становятся доступными через {n} дн. после оплаты.':
    'Каражат төлөмдөн кийин {n} күндө жеткиликтүү болот.',
  'История начислений': 'Чегерүүлөр тарыхы',
  'Пока нет начислений.': 'Азырынча чегерүүлөр жок.',
  Выплаты: 'Төлөп берүүлөр',
  'Пока нет выплат.': 'Азырынча төлөмдөр жок.',
  Начисление: 'Чегерүү',
  Возврат: 'Кайтаруу',
  Выплата: 'Төлөп берүү',
  Корректировка: 'Түзөтүү',
  'В обработке': 'Иштелүүдө',
  Отправлено: 'Жөнөтүлдү',
  Ошибка: 'Ката',
  'Реквизиты для выплат': 'Төлөм реквизиттери',
  'Выплаты скоро будут доступны. Загляните позже.':
    'Төлөмдөр жакында жеткиликтүү болот. Кийинчерээк кайрылыңыз.',
  'Добавьте реквизиты, чтобы получать выплаты за курсы.':
    'Курстар үчүн төлөмдөрдү алуу үчүн реквизиттерди кошуңуз.',
  'Кошелёк Finik': 'Finik капчыгы',
  'Банк по номеру телефона': 'Телефон номери боюнча банк',
  'Банковская карта': 'Банк картасы',
  'Номер карты': 'Карта номери',
  'Номер телефона': 'Телефон номери',
  'Сохранить реквизиты': 'Реквизиттерди сактоо',
  'Обновить реквизиты': 'Реквизиттерди жаңылоо',
  'Не удалось сохранить реквизиты.': 'Реквизиттерди сактоо мүмкүн болгон жок.',
  // Earnings polish round: chart + method cards + formatted inputs («Отмена»/«Проверяем…» live elsewhere).
  'Начисления по месяцам': 'Айлар боюнча чегерүүлөр',
  'Способ выплаты': 'Төлөм ыкмасы',
  Скоро: 'Жакында',
  Изменить: 'Өзгөртүү',
  'Банковские выплаты скоро — сейчас доступен кошелёк Finik.':
    'Банктык төлөмдөр жакында — азырынча Finik капчыгы жеткиликтүү.',
  'Проверьте номер карты — в нём есть ошибка.': 'Карта номерин текшериңиз — анда ката бар.',
  'Реквизиты шифруются и хранятся в замаскированном виде. Finik проверяет получателя перед сохранением.':
    'Реквизиттер шифрленип, маскаланган түрдө сакталат. Finik сактоодон мурун алуучуну текшерет.',
  'Реквизиты проверены Finik, зашифрованы и хранятся в замаскированном виде.':
    'Реквизиттер Finik тарабынан текшерилип, шифрленип, маскаланган түрдө сакталат.',
  'Выплаты приходят раз в месяц — примерно каждые 30 дней — на подключённый Finik-счёт.':
    'Төлөмдөр айына бир жолу — болжол менен ар 30 күндө — кошулган Finik эсебине келип турат.',

  // Students analytics (modules/students — labels sourced from frontend/web messages/ky/teacher.json)
  Студенты: 'Студенттер',
  'Ваши курсы': 'Сиздин курстар',
  'Активные студенты': 'Активдүү студенттер',
  Завершили: 'Аяктагандар',
  'Новые за неделю': 'Жаңы катталгандар',
  'Потоки заканчиваются': 'Агымдар жакында бүтөт',
  '{n} студентов': '{n} студент',
  'Пока нет курсов — создайте первый во вкладке «Курсы».':
    'Азырынча курстар жок — биринчисин «Курстар» өтмөгүнөн түзүңүз.',
  '← К панели': '← Панелге кайтуу',
  Записаны: 'Катталган',
  Завершаемость: 'Аяктоо деңгээли',
  'Студентов пока нет.': 'Азырынча студенттер жок.',
  Стрик: 'Серия',
  Активность: 'Акыркы аракет',
  'В графике': 'Жакшы',
  'В зоне риска': 'Тобокелде',
  Застопорился: 'Токтоп калган',
  'Не начал': 'Башталган жок',
  Завершил: 'Аяктады',
  '← К списку': '← Тизмеге кайтуу',
  'Студент не найден или больше не записан на поток.': 'Студент табылган жок же агымга катталуусу жок.',
  'Средний тест': 'Орточо тест',
  'Записан(а)': 'Катталган',
  'Прогресс по модулям': 'Модулдар боюнча прогресс',
  'Освоение тем': 'Темаларды өздөштүрүү',
  'В курсе пока нет модулей.': 'Курста азырынча модулдар жок.',
  'Студенты курса': 'Курстун студенттери',

  // Live sessions (modules/live)
  Эфиры: 'Эфирлер',
  ['Запланируйте эфир (Zoom, Google Meet…) — студентам потока покажем баннер, '
    + 'когда вы в эфире.']:
    'Эфирди пландаңыз (Zoom, Google Meet…) — эфирде болгонуңузда агымдын студенттерине баннер көрсөтөбүз.',
  'Тема эфира': 'Эфирдин темасы',
  'Ссылка для подключения (https://…)': 'Кошулуу шилтемеси (https://…)',
  '＋ Запланировать эфир': '＋ Эфирди пландоо',
  // Bileli 2026-08-03: create-form validation hints
  'Введите тему эфира': 'Эфирдин темасын жазыңыз',
  'Добавьте ссылку для подключения': 'Кошулуу шилтемесин кошуңуз',
  'Ссылка должна начинаться с https://': 'Шилтеме https:// менен башталышы керек',
  'Эфиров пока нет.': 'Азырынча эфирлер жок.',
  Запланирован: 'Пландалган',
  'В эфире': 'Эфирде',
  Завершён: 'Аяктаган',
  'Ссылка на эфир': 'Эфирдин шилтемеси',
  'В эфир': 'Эфирге',
  Завершить: 'Аяктоо',
  'Запись эфира': 'Эфирдин жазуусу',
  'Ссылка на запись (https://…)': 'Жазуунун шилтемеси (https://…)',
  Сохранить: 'Сактоо',
  'Не удалось создать эфир.': 'Эфирди түзүү мүмкүн болгон жок.',
  'Не удалось начать эфир.': 'Эфирди баштоо мүмкүн болгон жок.',
  'В этом потоке уже идёт эфир — сначала завершите его.':
    'Бул агымда эфир жүрүп жатат — адегенде аны аяктаңыз.',
  'Не удалось завершить эфир.': 'Эфирди аяктоо мүмкүн болгон жок.',
  'Не удалось сохранить запись.': 'Жазууну сактоо мүмкүн болгон жок.',
  'Не удалось отменить эфир.': 'Эфирди жокко чыгаруу мүмкүн болгон жок.',
  'Учеников просят эфир: {n}': 'Окуучулар эфир сурап жатышат: {n}',

  // Live meetings — native Telegram group-call transport (kind picker + hosting).
  'Проведите эфир — прямо в Telegram-пространстве потока или по внешней ссылке.':
    'Эфир өткөрүңүз — түз агымдын Telegram-мейкиндигинде же тышкы шилтеме аркылуу.',
  'Звонок в Telegram': 'Telegram чалуусу',
  'Внешняя ссылка': 'Тышкы шилтеме',
  'Начать звонок': 'Чалууну баштоо',
  'Запустить звонок': 'Чалууну иштетүү',
  'Пространство потока ещё не создано — создайте его в «Сообществах», чтобы вести звонок в Telegram.':
    'Агымдын мейкиндиги али түзүлө элек — Telegram аркылуу чалуу жүргүзүү үчүн аны «Коомчулуктар» бөлүмүндө түзүңүз.',
  'Пространство потока ещё не создано — звонок не запустить.':
    'Агымдын мейкиндиги али түзүлө элек — чалууну иштетүү мүмкүн эмес.',
  'Не удалось запустить звонок.': 'Чалууну иштетүү мүмкүн болгон жок.',
  'Не удалось загрузить эфиры.': 'Эфирлерди жүктөө мүмкүн болгон жок.',
  'Не удалось загрузить список — нажмите ещё раз.':
    'Тизмени жүктөө мүмкүн болгон жок — дагы бир жолу басыңыз.',
  'Выполняем…': 'Аткарылууда…',
  'Пространство потока ещё готовится — попробуйте через минуту.':
    'Агымдын мейкиндиги даярдалып жатат — бир мүнөттөн кийин аракет кылыңыз.',
  'Этот браузер не поддерживает звонки — откройте в приложении Telegram или другом браузере.':
    'Бул браузер чалууларды колдобойт — Telegram колдонмосунан же башка браузерден ачыңыз.',
  'Сначала откройте пространство потока (в «Сообществах»), затем запустите звонок.':
    'Адегенде агымдын мейкиндигин ачыңыз («Коомчулуктар» бөлүмүндө), андан кийин чалууну иштетиңиз.',
  'Выдаём права ведущего… Запустите звонок ещё раз через пару секунд.':
    'Алып баруучунун укуктарын берип жатабыз… Бир нече секунддан кийин чалууну кайра иштетиңиз.',
  'Кто?': 'Ким?',
  Скрыть: 'Жашыруу',
  'Пока никто не проголосовал.': 'Азырынча эч ким добуш берген жок.',

  // Announcements panel (AnnouncementsPanel / useAnnouncements).
  // «Поток {n}», «Опубликовать», «Отправляем…» already translated above (cohorts/publish sections).
  Объявления: 'Жарыялар',
  ['У курса ещё нет Telegram-сообщества — объявления публиковать некуда. Оно создаётся на '
    + 'странице «Сообщества»: опубликуйте курс и нажмите «Синхронизировать» — появится '
    + 'форум потока с темами «Жарыялар» и «Талкуу».']:
    'Курстун Telegram-коомчулугу азырынча жок — жарыяларды жарыялай турган жер жок. Ал «Коомчулуктар» '
    + 'барагында түзүлөт: курсту жарыялап, «Синхрондоштуруу» баскычын басыңыз — «Жарыялар» жана «Талкуу» '
    + 'темалары бар агымдын форуму пайда болот.',
  'Объявление опубликовано в Telegram-пространстве курса':
    'Жарыя курстун Telegram-мейкиндигине жарыяланды',
  'Открыть «Сообщества» →': '«Коомчулуктар» бөлүмүн ачуу →',
  'Пространство ещё не загружено в этом Telegram-аккаунте — откройте его один раз, затем вернитесь.':
    'Мейкиндик бул Telegram-аккаунтта азырынча жүктөлө элек — аны бир жолу ачып, кийин кайтып келиңиз.',
  'Открыть пространство →': 'Мейкиндикти ачуу →',
  'Текст объявления — увидят все участники пространства…':
    'Жарыянын тексти — мейкиндиктин бардык катышуучулары көрөт…',
  'Объявлений пока нет — напишите первое.': 'Азырынча жарыялар жок — биринчисин жазыңыз.',
  'Не удалось загрузить объявления.': 'Жарыяларды жүктөө мүмкүн болгон жок.',
  'Не удалось отправить объявление.': 'Жарыяны жөнөтүү мүмкүн болгон жок.',
  'Написать в Telegram': 'Telegram аркылуу жазуу',
  'Студент не указал @username в Telegram': 'Студент Telegram\'да @username көрсөткөн эмес',
  'Студент не указал @username — написать нельзя': 'Студент @username көрсөткөн эмес — жазуу мүмкүн эмес',

  // Teacher workspaces list (TeachList / TeacherCourseCard)
  'Личное пространство': 'Жеке мейкиндик',
  Создатель: 'Түзүүчү',
  'Рабочие пространства': 'Иш мейкиндиктери',
  // Teach-pages round (students/spaces/earnings/provider redesigns)
  активных: 'активдүү',
  завершили: 'аяктады',
  'новых за неделю': 'жумада жаңы',
  'потоков заканчиваются': 'агымдар аяктап жатат',
  '{n} активных': '{n} активдүү',
  '{n} завершили': '{n} аяктады',
  '{n} потоков': '{n} агым',
  'пока без студентов': 'азырынча студенттер жок',
  'Telegram-группы ваших потоков и витрина школы — создаются от имени этого аккаунта.':
    'Агымдарыңыздын Telegram-топтору жана мектептин витринасы — ушул аккаунттун атынан түзүлөт.',
  'Как это работает →': 'Бул кантип иштейт →',
  'Витрина школы': 'Мектептин витринасы',
  работает: 'иштейт',
  'Классы потоков': 'Агымдардын класстары',
  'класс потока': 'агымдын классы',
  создано: 'түзүлгөн',
  'Всего заработано': 'Бардыгы табылды',
  'За этот период начислений нет.': 'Бул мезгилде чегерүүлөр жок.',
  Неделя: 'Апта',
  Месяц: 'Ай',
  Год: 'Жыл',
  Всё: 'Баары',
  'Школа на Bileli': 'Bileli мектеби',
  '↗ Поделиться': '↗ Бөлүшүү',
  'Ссылка скопирована ✓': 'Шилтеме көчүрүлдү ✓',
  'Витрина в Telegram': 'Telegram витринасы',
  'Опубликованных курсов пока нет.': 'Азырынча жарыяланган курстар жок.',
  'Подборки ваших курсов с баннером на главной у студентов — соберите трек и продвигайте его.':
    'Курстарыңыздын топтомдору — студенттердин башкы бетиндеги баннер менен. Трек түзүп, жарнамалаңыз.',
  // Teach-header V3 (панель с рейкой): switcher, inline create-space, role chip, stat-tile hints.
  'Сменить пространство': 'Мейкиндикти алмаштыруу',
  'Новое пространство': 'Жаңы мейкиндик',
  'Название школы': 'Мектептин аталышы',
  'Не удалось переименовать школу.': 'Мектептин атын өзгөртүү мүмкүн болгон жок.',
  'Личное пространство называется по имени профиля — смените имя в профиле, и название обновится.':
    'Жеке мейкиндик профилдин аты менен аталат — профилдеги атты өзгөртсөңүз, аталышы жаңырат.',
  'Не удалось создать пространство.': 'Мейкиндикти түзүү мүмкүн болгон жок.',
  'Команда и настройки': 'Команда жана жөндөөлөр',
  'Прокрутить к курсам': 'Курстарга өтүү',
  'Открыть «Студенты»': '«Студенттер» бетин ачуу',
  'Вы инструктор': 'Сиз инструкторсуз',
  'Назначенные вам курсы появятся здесь.': 'Сизге дайындалган курстар ушул жерде көрүнөт.',
  'Нажмите «＋ Новый курс» — черновик откроется сразу, потоки добавите внутри курса.':
    '«＋ Жаңы курс» баскычын басыңыз — каралама дароо ачылат, агымдарды курстун ичинде кошосуз.',
  '＋ Создать': '＋ Түзүү',
  курсов: 'курс',
  '＋ Поток': '＋ Агым',
  '＋ Новый курс': '＋ Жаңы курс',
  'Создайте свой первый курс': 'Биринчи курсуңузду түзүңүз',
  '«Новый курс» — уроки в своём темпе. «Поток» — с датами и набором студентов.':
    '«Жаңы курс» — өз ыргагыңыздагы сабактар. «Агым» — даталары жана студенттерди кабыл алуусу менен.',
  студентов: 'студент',
  потоков: 'агым', // design-C hero stats («N потоков»)
  'Без названия': 'Аталышы жок',

  // Course state / type labels (teacher.api.ts maps — translated at the usage site)
  Черновик: 'Долбоор',
  Опубликован: 'Жарыяланган',
  'В архиве': 'Архивде',
  Самостоятельный: 'Өз алдынча',
  Поток: 'Агым',

  // Publish-readiness checklist (publish-readiness.ts map — translated at the usage site)
  'Название курса': 'Курстун аталышы',
  'Имя профиля': 'Профилдин аты',
  'Хотя бы одна предметная категория': 'Жок дегенде бир предметтик категория',
  'Хотя бы один урок': 'Жок дегенде бир сабак',
  'Хотя бы один поток': 'Жок дегенде бир агым',

  // Course editor (CourseEditorView / AutosaveField)
  Описание: 'Сүрөттөмө',
  'Расскажите, о чём курс…': 'Курс эмне жөнүндө экенин айтып бериңиз…',
  'Открыть витрину курса': 'Курстун витринасын ачуу',
  // Bileli 2026-07-29 (video queue round). Bunny's free shared encoder queues every upload for 10–17
  // minutes and staying on that tier is a settled decision — so «в очереди» is the NORMAL state a teacher
  // sees on every video, and it needs Kyrgyz as much as any other everyday string.
  // Bileli 2026-07-30 (#8): friendlier queued copy (confirms the upload landed; then it's just the wait).
  'Видео загружено — сейчас в очереди на обработку. Обычно несколько минут, можно заполнять другие уроки.':
    'Видео жүктөлдү — азыр иштетүү кезегинде. Адатта бир нече мүнөт, башка сабактарды толтура берсеңиз болот.',
  'Видео в очереди на обработку': 'Видео иштетүү кезегинде',
  // Live-meetings diary round: the notes field + the delete confirmation.
  'Заметки к эфиру (необязательно)': 'Эфирге эскертүүлөр (милдеттүү эмес)',
  'Удалить эфир? Звонок в Telegram или встреча в Zoom не завершатся — выйдите вручную.':
    'Эфирди өчүрөсүзбү? Telegram\'дагы чалуу же Zoom\'дагы жолугушуу аяктабайт — кол менен чыгыңыз.',
  // Short titles (Telegram topic name). «Краткое название» keeps the «·  KY/RU» suffix untranslated —
  // the language codes read the same in both.
  'Краткое название · KY': 'Кыскача аталышы · KY',
  'Краткое название · RU': 'Кыскача аталышы · RU',
  'Короткое имя для Telegram — до 60 символов. Необязательно.':
    'Telegram үчүн кыскача аталыш — 60 белгиге чейин. Милдеттүү эмес.',
  'Тип курса': 'Курстун тиби',
  'Тип можно менять только у черновика.': 'Типти долбоордо гана өзгөртсө болот.',
  // The «Уровень» control's fourth segment — the CLEAR option, not an empty state. The three level
  // names live in ky.learn (the student pill reads the same map) and «Уровень» itself in ky.common.
  'Не указан': 'Көрсөтүлгөн эмес',
  сохранено: 'сакталды',

  // Categories (CategoryPicker / CategorySelect)
  'Категории (до 3 предметов)': 'Категориялар (3 предметке чейин)',
  Категории: 'Категориялар',
  'Выберите категории…': 'Категорияларды тандаңыз…',
  'Поиск категории…': 'Категория издөө…',
  Предметы: 'Предметтер',
  Цели: 'Максаттар',
  'Ничего не найдено.': 'Эч нерсе табылган жок.',

  // Outcomes (OutcomesEditor)
  'Чему научатся студенты': 'Студенттер эмнени үйрөнүшөт',
  'Напр. Решать задачи ОРТ по алгебре': 'Мис. Алгебра боюнча ЖРТ маселелерин чыгаруу',
  '＋ Добавить пункт': '＋ Пункт кошуу',

  // Cohorts / pricing (CohortCard / CohortsEditor)
  'Не удалось сохранить.': 'Сактоо мүмкүн болгон жок.',
  'Название потока': 'Агымдын аталышы',
  Цена: 'Баасы',
  Платный: 'Акылуу',
  Начало: 'Башталышы',
  Окончание: 'Аякташы',
  'Количество мест': 'Орундардын саны',
  'Без лимита': 'Чексиз',
  'Удалить этот поток?': 'Бул агымды өчүрөсүзбү?',
  'Удалить поток': 'Агымды өчүрүү',
  'Поток {n}': 'Агым {n}',
  'Не удалось добавить поток.': 'Агым кошуу мүмкүн болгон жок.',
  'Не удалось удалить поток.': 'Агымды өчүрүү мүмкүн болгон жок.',
  'Цена и потоки': 'Баасы жана агымдар',
  'Добавьте хотя бы один поток, чтобы опубликовать курс.':
    'Курсту жарыялоо үчүн жок дегенде бир агым кошуңуз.',
  'Добавляем…': 'Кошуп жатабыз…',

  // Publish panel (PublishPanel)
  'Готовность к публикации': 'Жарыялоого даярдык',
  Опубликовать: 'Жарыялоо',
  'Как вас зовут?': 'Атыңыз ким?',
  'Имя будет показано ученикам как автор курса.': 'Аты окуучуларга курстун автору катары көрсөтүлөт.',
  'Имя и фамилия': 'Аты-жөнү',
  'Сохранить и опубликовать': 'Сактоо жана жарыялоо',
  'В архив': 'Архивге',
  'Просмотр курса': 'Курсту көрүү',
  'Удалить курс безвозвратно?': 'Курсту биротоло өчүрөсүзбү?',
  'Удалить курс': 'Курсту өчүрүү',

  // Sign-in gate (TeachList)
  'Не удалось войти в Bileli': 'Bileli\'ге кирүү мүмкүн болгон жок',
  'Проверьте соединение и попробуйте ещё раз.': 'Байланышты текшерип, кайра аракет кылыңыз.',

  // Course editor errors (useCourseEditor)
  'Не удалось опубликовать курс.': 'Курсту жарыялоо мүмкүн болгон жок.',
  'Не удалось архивировать курс.': 'Курсту архивдөө мүмкүн болгон жок.',
  'Не удалось удалить курс.': 'Курсту өчүрүү мүмкүн болгон жок.',

  // Curriculum (CurriculumEditor / ModuleCard / useCurriculum / useDraftLesson)
  'Пока нет модулей — добавьте первый ниже.': 'Азырынча модулдар жок — биринчисин төмөндө кошуңуз.',
  'Название модуля…': 'Модулдун аталышы…',
  'Открыть →': 'Ачуу →',
  'Удалить модуль': 'Модулду өчүрүү',
  // Bileli 2026-07-30 (R3): confirm before deleting a module (it cascades its lessons).
  'Удалить модуль со всеми уроками?': 'Модулду бардык сабактары менен өчүрөсүзбү?',
  'Удалить урок': 'Сабакты өчүрүү',
  '＋ Добавить урок': '＋ Сабак кошуу',
  'Перетащите, чтобы изменить порядок': 'Иретин өзгөртүү үчүн сүйрөңүз',
  'Файл не подходит.': 'Файл туура келбейт.',
  'Нет рабочего пространства.': 'Иш мейкиндиги жок.',
  'Не удалось создать урок.': 'Сабакты түзүү мүмкүн болгон жок.',
  'Напишите текст урока.': 'Сабактын текстин жазыңыз.',

  // Course media (CourseMediaEditor / useCourseMedia)
  'Обложка и трейлер': 'Мукаба жана трейлер',
  'Загрузка видео… {pct}%': 'Видео жүктөлүүдө… {pct}%',
  'Обработка видео… {pct}': 'Видео иштетилүүдө… {pct}',
  'Видео обрабатывается…': 'Видео иштетилип жатат…',
  'Обложка курса': 'Курстун мукабасы',
  // Bileli 2026-07-30: friendlier trailer copy (behaviour: pick → local preview → upload by button).
  'Добавить видео-трейлер': 'Видео-трейлер кошуу',
  'Короткое видео о курсе — поднимает записи. Сначала посмотрите его здесь, загрузим по кнопке.':
    'Курс жөнүндө кыска видео — жазылууну көбөйтөт. Адегенде аны бул жерден көрүңүз, кнопка менен жүктөйбүз.',
  'Загрузка {pct}%': 'Жүктөлүүдө {pct}%',
  'Заменить обложку': 'Мукабаны алмаштыруу',
  '＋ Обложка': '＋ Мукаба',
  'Запуск…': 'Башталууда…',
  'Заменить видео': 'Видеону алмаштыруу',
  Отмена: 'Жокко чыгаруу',
  'Не удалось загрузить обложку.': 'Мукабаны жүктөө мүмкүн болгон жок.',
  'Не удалось начать загрузку видео.': 'Видеону жүктөөнү баштоо мүмкүн болгон жок.',

  // Lesson editors (LessonEditorView / LessonEditorPane / useLessonEditor)
  '← Назад к курсу': '← Курска кайтуу',
  'Название урока': 'Сабактын аталышы',
  // Bileli 2026-07-30 (R3): one-line create-lesson header — placeholder replaces the dropped label.
  'Название урока — по умолчанию имя файла': 'Сабактын аталышы — демейки боюнча файлдын аты',
  'Содержание урока': 'Сабактын мазмуну',
  'Напишите текст урока…': 'Сабактын текстин жазыңыз…',
  'PDF-файл урока': 'Сабактын PDF файлы',
  'Заменить PDF': 'PDF алмаштыруу',
  '＋ Загрузить PDF': '＋ PDF жүктөө',
  'PDF до 50 МБ. Студенты увидят его во встроенном просмотрщике.':
    'PDF 50 МБ чейин. Студенттер аны орнотулган көрсөткүчтөн көрүшөт.',
  'Редактор для этого типа урока скоро появится.': 'Бул сабак тиби үчүн редактор жакында пайда болот.',
  'Не удалось загрузить PDF.': 'PDF жүктөө мүмкүн болгон жок.',
  'Удалить урок безвозвратно?': 'Сабакты биротоло өчүрөсүзбү?',
  'Видео не прикреплено.': 'Видео тиркелген эмес.',
  'Описание урока': 'Сабактын сүрөттөмөсү',
  'Короткое описание (видно студентам под уроком)…': 'Кыска сүрөттөмө (студенттерге сабактын астында көрүнөт)…',
  '‹ Предыдущий': '‹ Мурунку',
  'Следующий ›': 'Кийинки ›',
  '＋ Следующий урок': '＋ Кийинки сабак',
  // Bileli 2026-07-30 (#9 / R2-D): move between modules explicitly (was a silent cross-boundary jump);
  // at the course's end, create the next module. «‹ Предыдущий модуль» shows in the empty-module screen.
  '‹ Предыдущий модуль': '‹ Мурунку модуль',
  '→ Следующий модуль: {name}': '→ Кийинки модуль: {name}',
  '＋ Создать следующий модуль': '＋ Кийинки модуль түзүү',
  'Новый модуль': 'Жаңы модуль',

  // Module workspace (ModuleWorkspaceView / WorkspaceSidebar / LessonDraftEditor)
  Обрабатывается: 'Иштетилүүдө',
  'Переименовать модуль': 'Модулдун атын өзгөртүү',
  '＋ Урок': '＋ Сабак',
  'Выберите урок справа': 'Оң жактан сабакты тандаңыз',
  'Или создайте новый — видео, текст, PDF или тест.': 'Же жаңысын түзүңүз — видео, текст, PDF же тест.',
  '＋ Новый урок': '＋ Жаңы сабак',
  'Новый урок': 'Жаңы сабак',
  'По умолчанию — имя файла': 'Демейки — файлдын аты',
  'Выбрать видео': 'Видео тандоо',
  ['MP4, MOV или WebM. Загрузится в фоне — можно сразу продолжать работу; '
    + 'загрузка переживает перезагрузку страницы.']:
    'MP4, MOV же WebM. Фондо жүктөлөт — ишти дароо улантса болот; жүктөө барак жаңыланганда да улана берет.',
  'Выбрать PDF': 'PDF тандоо',
  'Создать урок': 'Сабак түзүү',
  'Создайте тест, затем добавьте вопросы в конструкторе.':
    'Тест түзүңүз, андан кийин конструктордо суроолорду кошуңуз.',
  'Создать тест': 'Тест түзүү',

  // Teacher Q&A inbox (CourseDiscussionsPanel / useCourseDiscussions)
  'Урок: {title}': 'Сабак: {title}',
  отвечено: 'жооп берилди',
  'без ответа': 'жоопсуз',
  'Ответов пока нет.': 'Азырынча жооптор жок.',
  'Ответить ученику…': 'Окуучуга жооп берүү…',
  'Открыть обсуждение': 'Талкууну ачуу',
  'Закрыть обсуждение': 'Талкууну жабуу',
  'Вопросы учеников': 'Окуучулардын суроолору',
  'Без ответа': 'Жоопсуз',
  'Все вопросы отвечены': 'Бардык суроолорго жооп берилди',
  'Вопросов пока нет.': 'Азырынча суроолор жок.',
  'Не удалось загрузить вопросы.': 'Суроолорду жүктөө мүмкүн болгон жок.',
  'Не удалось изменить статус.': 'Статусту өзгөртүү мүмкүн болгон жок.',

  // Quiz builder (QuizEditor / QuizQuestionCard / useQuizQuestions)
  'Выбор ответа': 'Жооп тандоо',
  'Верно / неверно': 'Туура / туура эмес',
  'Короткий ответ': 'Кыска жооп',
  // phone one-row add strip short labels
  Выбор: 'Тандоо',
  'Да/Нет': 'Ооба/Жок',
  Ответ: 'Жооп',
  'Пока в тесте нет вопросов, студенты видят пустой урок: пройти его нельзя, и курс не завершить.':
    'Тестте суроолор жок болсо, студенттер бош сабакты көрөт: аны өтүү мүмкүн эмес, курсту аяктоо да болбойт.',
  'Добавьте вопрос ниже или удалите урок.': 'Төмөндө суроо кошуңуз же сабакты өчүрүңүз.',
  'Тест без вопросов — урок нельзя пройти': 'Суроосуз тест — сабакты өтүү мүмкүн эмес',
  'Банк вопросов курса ({n})': 'Курстун суроолор банкы ({n})',
  'Без текста': 'Тексти жок',
  '＋ Добавить': '＋ Кошуу',
  черновик: 'долбоор',
  'Убрать из теста': 'Тесттен алып салуу',
  'Удалить вопрос из банка курса (и из всех тестов)?':
    'Суроону курстун банкынан (жана бардык тесттерден) өчүрөсүзбү?',
  Отменить: 'Жокко чыгаруу',
  'Текст вопроса…': 'Суроонун тексти…',
  'Правильный ответ': 'Туура жооп',
  'Убрать вариант': 'Вариантты алып салуу',
  'Принимаемый ответ…': 'Кабыл алынуучу жооп…',
  Убрать: 'Алып салуу',
  '＋ Ответ': '＋ Жооп',
  'Без учёта регистра': 'Регистрди эске албастан',
  'Пояснение (показывается после ответа)…': 'Түшүндүрмө (жооптон кийин көрсөтүлөт)…',
  'Пересмотреть при ошибке (необязательно)': 'Ката кетсе кайра көрүү (милдеттүү эмес)',
  Нет: 'Жок',
  'Момент видео (минуты:секунды)': 'Видеонун учуру (мүнөт:секунд)',
  'После неверного ответа студент увидит кнопку «Пересмотреть» — видео откроется с этого момента.':
    'Туура эмес жооптон кийин студент «Кайра көрүү» баскычын көрөт — видео ушул учурдан ачылат.',
  'Длину видео не удалось определить — возможно, оно ещё обрабатывается.':
    'Видеонун узактыгын аныктоо мүмкүн болгон жок — балким, ал азырынча иштетилүүдө.',
  'После неверного ответа студент увидит кнопку «Пересмотреть» и перейдёт к этому уроку.':
    'Туура эмес жооптон кийин студент «Кайра көрүү» баскычын көрүп, ушул сабакка өтөт.',
  'Сохранить вопрос': 'Суроону сактоо',
  'Не удалось сохранить вопрос.': 'Суроону сактоо мүмкүн болгон жок.',
  'Вопрос сохранён, но не добавлен в тест — попробуйте ещё раз или добавьте его из банка.':
    'Суроо сакталды, бирок тестке кошулган жок — кайра аракет кылыңыз же аны банктан кошуңуз.',
  'Не удалось сохранить изменения.': 'Өзгөртүүлөрдү сактоо мүмкүн болгон жок.',
  'Не удалось удалить вопрос.': 'Суроону өчүрүү мүмкүн болгон жок.',
  'Не удалось убрать вопрос из теста.': 'Суроону тесттен алып салуу мүмкүн болгон жок.',
  'Не удалось добавить вопрос из банка.': 'Банктан суроо кошуу мүмкүн болгон жок.',
  'Не удалось изменить порядок.': 'Иретти өзгөртүү мүмкүн болгон жок.',

  // Programs studio (PR #184 — modules/programs). Identical-in-ky omitted: Программы placeholders,
  // «Бейдж (KY/RU)» (identical word), example placeholders.
  Программы: 'Программалар',
  программ: 'программа',
  '＋ Новая программа': '＋ Жаңы программа',
  'Новая программа': 'Жаңы программа',
  'Название (KY)': 'Аталышы (KY)',
  'Название (RU)': 'Аталышы (RU)',
  'Оба названия обязательны, до 200 символов.': 'Эки аталыш тең милдеттүү, 200 белгиге чейин.',
  Создать: 'Түзүү',
  'Создаю…': 'Түзүлүүдө…',
  'Не удалось создать программу.': 'Программаны түзүү мүмкүн болгон жок.',
  'Соберите курсы в программу': 'Курстарды программага бириктириңиз',
  'Программа — подборка ваших курсов. Она появится на главной, если админ добавит её в карусель.':
    'Программа — курстарыңыздын топтому. Админ каруселге кошсо, ал башкы бетте чыгат.',
  'В подборке': 'Тандалмада',
  Опубликована: 'Жарыяланган',
  '← К программам': '← Программаларга',
  'Не удалось загрузить программу.': 'Программаны жүктөө мүмкүн болгон жок.',
  'Подзаголовок (KY)': 'Кошумча сүрөттөмө (KY)',
  'Подзаголовок (RU)': 'Кошумча сүрөттөмө (RU)',
  'Бейдж — короткая надпись на баннере (до 50 символов). Пусто — покажем «Программа».':
    'Бейдж — баннердеги кыска жазуу (50 белгиге чейин). Бош болсо — «Программа» көрсөтөбүз.',
  'Обложка баннера': 'Баннердин мукабасы',
  'Обложка программы': 'Программанын мукабасы',
  'Обложка 16:9 — фон баннера на главной.': 'Мукаба 16:9 — башкы беттеги баннердин фону.',
  'Убрать обложку': 'Мукабаны алып салуу',
  'Не удалось убрать обложку.': 'Мукабаны алып салуу мүмкүн болгон жок.',
  'Курсы программы': 'Программанын курстары',
  'Добавьте курсы — порядок в списке станет порядком на странице программы.':
    'Курстарды кошуңуз — тизмедеги ирет программанын барагындагы ирет болот.',
  'Скрыт до публикации': 'Жарыяланганга чейин көрүнбөйт',
  Перетащить: 'Сүйрөө',
  'Убрать курс': 'Курсту алып салуу',
  '＋ Добавить курс': '＋ Курс кошуу',
  'Найти курс…': 'Курс издөө…',
  'У вас пока нет курсов.': 'Сизде азырынча курстар жок.',
  'Не удалось добавить курс.': 'Курс кошуу мүмкүн болгон жок.',
  'Не удалось убрать курс.': 'Курсту алып салуу мүмкүн болгон жок.',
  Ссылка: 'Шилтеме',
  'Карусель на главной': 'Башкы беттеги карусель',
  'В подборке на главной': 'Башкы беттеги тандалмада',
  'Подборку на главной настраивает администратор Bileli.':
    'Башкы беттеги тандалманы Bileli администратору жөндөйт.',
  'Опубликовать снова': 'Кайра жарыялоо',
  'Программа исчезнет с главной и из подборки. Архивировать?':
    'Программа башкы беттен жана тандалмадан өчөт. Архивдейбизби?',
  Архивировать: 'Архивдөө',
  'Открыть страницу →': 'Баракчаны ачуу →',
  'Название не может быть пустым.': 'Аталышы бош болбошу керек.',
  'Не удалось сохранить программу.': 'Программаны сактоо мүмкүн болгон жок.',
  'Не удалось опубликовать программу.': 'Программаны жарыялоо мүмкүн болгон жок.',
  'Не удалось архивировать программу.': 'Программаны архивдөө мүмкүн болгон жок.',
  // Editor redesign (banner designer) — single-language labels + hints. «Бейдж»/«ОРТ 2026» identical → omitted.
  Название: 'Аталышы',
  Подзаголовок: 'Кошумча сүрөттөмө',
  'Коротко о программе…': 'Программа жөнүндө кыскача…',
  'Язык баннера': 'Баннердин тили',
  'Соберите курсы в подборку — она станет баннером на главной.':
    'Курстарды топтомго бириктириңиз — ал башкы беттеги баннерге айланат.',

  // Org (school) settings on the teach profile (modules/orgs — PR #184 provider profile).
  'Настройки школы': 'Мектеп жөндөөлөрү',
  'Логотип школы': 'Мектептин логотиби',
  'Заменить логотип': 'Логотипти алмаштыруу',
  'Убрать логотип': 'Логотипти алып салуу',
  'Не удалось загрузить логотип.': 'Логотипти жүктөө мүмкүн болгон жок.',
  'Не удалось убрать логотип.': 'Логотипти алып салуу мүмкүн болгон жок.',
  'Не удалось сохранить описание.': 'Сүрөттөмөнү сактоо мүмкүн болгон жок.',
  'О школе': 'Мектеп жөнүндө',
  'Расскажите студентам о себе или школе…': 'Студенттерге өзүңүз же мектебиңиз жөнүндө айтып бериңиз…',
  'Открыть страницу школы →': 'Мектептин баракчасын ачуу →',
  // ── Org invites + members (backend PRs #220/#222) ──
  'Участники школы': 'Мектептин мүчөлөрү',
  '＋ Пригласить преподавателя': '＋ Мугалим чакыруу',
  Владелец: 'Ээси',
  'Админ управляет школой: приглашения, участники, настройки.':
    'Админ мектепти башкарат: чакыруулар, мүчөлөр, баптоолор.',
  'Преподаватель ведёт курсы школы, но не управляет ею.':
    'Мугалим мектептин курстарын жүргүзөт, бирок аны башкарбайт.',
  'Создать ссылку': 'Шилтеме түзүү',
  'Создаём…': 'Түзүлүүдө…',
  'Ссылка показывается один раз — скопируйте её сейчас. Действует 7 дней, на одного человека.':
    'Шилтеме бир жолу гана көрсөтүлөт — азыр көчүрүп алыңыз. 7 күн жарактуу, бир кишиге.',
  Копировать: 'Көчүрүү',
  'Скопировано!': 'Көчүрүлдү!',
  'Отправить в Telegram': 'Telegramга жөнөтүү',
  'Активные приглашения': 'Активдүү чакыруулар',
  'истекает через {n} дн.': '{n} күндөн кийин бүтөт',
  Отозвать: 'Кайтарып алуу',
  Вы: 'Сиз',
  Удалить: 'Өчүрүү',
  'Точно удалить?': 'Чын эле өчүрөсүзбү?',
  // «Команда» page (the panels' new home — moved off the profile). The tab label «Команда» itself is
  // the same loanword in Kyrgyz → deliberately omitted (t() falls back to RU).
  'Участники школы, ссылки-приглашения и настройки страницы.':
    'Мектептин мүчөлөрү, чакыруу шилтемелери жана баракча жөндөөлөрү.',
  'Школы пока нет': 'Азырынча мектеп жок',
  'Попросите у владельца школы ссылку-приглашение — или создайте свой курс на вкладке «Курсы».':
    'Мектептин ээсинен чакыруу шилтемесин сураңыз — же «Курстар» өтмөгүнөн өз курсуңузду түзүңүз.',
  'Приглашениями и настройками школы управляют владелец и админы.':
    'Мектептин чакырууларын жана жөндөөлөрүн ээси менен админдер башкарат.',
  'Команда и настройки школы': 'Команда жана мектеп жөндөөлөрү',
  // Redemption overlay (OrgInviteGate)
  'Вы уже участник «{org}»': 'Сиз «{org}» мектебинин мүчөсүсүз',
  'Вы присоединились к «{org}»!': 'Сиз «{org}» мектебине кошулдуңуз!',
  'Открыть школу': 'Мектепти ачуу',
  'Ссылка-приглашение недействительна': 'Чакыруу шилтемеси жараксыз',
  'Ссылка больше не действует': 'Шилтеме мындан ары жарактуу эмес',
  'Не удалось открыть приглашение': 'Чакырууну ачуу мүмкүн болгон жок',
  'Она истекла, отозвана или уже использована. Попросите новую ссылку.':
    'Ал бүткөн, кайтарылып алынган же колдонулган. Жаңы шилтеме сураңыз.',
  'Проверьте, что ссылка скопирована полностью.': 'Шилтеме толук көчүрүлгөнүн текшериңиз.',
  'Присоединиться к «{org}»?': '«{org}» мектебине кошулосузбу?',
  'Вас приглашают как админа — с правами управления школой.':
    'Сизди админ катары чакырышууда — мектепти башкаруу укуктары менен.',
  'Вас приглашают преподавать в этой школе.': 'Сизди бул мектепте сабак берүүгө чакырышууда.',
  'Вас приглашают стать совладельцем школы — с полным доступом, включая доходы.':
    'Сизди мектептин тең ээси болууга чакырышууда — толук укуктар, анын ичинде кирешелер.',
  'Вас приглашают как инструктора — помогать на курсах этой школы.':
    'Сизди инструктор катары чакырышууда — мектептин курстарына жардам берүү үчүн.',
  'Присоединяемся…': 'Кошулуудабыз…',
  Присоединиться: 'Кошулуу',
  'Не сейчас': 'Азыр эмес',
  'Не удалось создать ссылку.': 'Шилтеме түзүү мүмкүн болгон жок.',
  'Не удалось отозвать ссылку.': 'Шилтемени кайтарып алуу мүмкүн болгон жок.',
  'Не удалось удалить участника.': 'Мүчөнү өчүрүү мүмкүн болгон жок.',
  'Не удалось присоединиться.': 'Кошулуу мүмкүн болгон жок.',
  // «Доходы» mock-parity restyle + «Сообщества» hero (2026-07-26 follow-up)
  'Доступно к выводу': 'Чыгарууга жеткиликтүү',
  Вывести: 'Чыгаруу',
  'В ожидании': 'Күтүүдө',
  'За всё время': 'Бардык убакыт ичинде',
  'Последние операции': 'Акыркы операциялар',
  'Пока нет операций.': 'Азырынча операциялар жок.',
  'За этот период операций нет.': 'Бул мезгилде операциялар жок.',
  'не указаны': 'көрсөтүлгөн эмес',
  изменить: 'өзгөртүү',
  добавить: 'кошуу',
  Поступления: 'Түшүүлөр',
  неделя: 'жума',
  год: 'жыл',
  'всё время': 'бардык убакыт',
  'Создаётся автоматически после публикации курса — нажмите «Синхронизировать».':
    'Курс жарыялангандан кийин автоматтык түрдө түзүлөт — «Синхрондоштуруу» баскычын басыңыз.',
  // Space-requeue round (#280): FAILED provisioning jobs + «Повторить» (Повторить itself is in common)
  'Не удалось создать': 'Түзүү мүмкүн болгон жок',
  'Попыток: {n}': 'Аракеттер: {n}',
  // Payout-requests + showroom-fields round (#285/#287)
  'Заявка отправлена': 'Арыз жөнөтүлдү',
  'Отправляем…': 'Жөнөтүлүүдө…',
  'Заявка от {d} — ждёт ближайшей выплаты.': '{d} арызы — жакынкы төлөмдү күтүүдө.',
  'Не удалось отправить заявку. Попробуйте ещё раз.':
    'Арызды жөнөтүү мүмкүн болгон жок. Дагы аракет кылыңыз.',
  'Заявка на вывод': 'Чыгарууга арыз',
  'Ждёт выплаты': 'Төлөмдү күтүүдө',
  Исполнена: 'Аткарылды',
  Отменена: 'Жокко чыгарылды',
  создаётся: 'түзүлүүдө',
  'Группа-витрина создаётся — обновите страницу через минуту.':
    'Витрина-топ түзүлүп жатат — бир мүнөттөн кийин баракты жаңыртыңыз.',
  // The destructive requeue (#285 §3.4) — the armed label must ask about TELEGRAM, not name a mode.
  'Форум удалён из Telegram?': 'Форум Telegram’дан өчүрүлгөнбү?',
  'Да, создать новый': 'Ооба, жаңысын түзүү',
  // Floating live-call window (call-dock round)
  'Живой урок': 'Жандуу сабак',
  Развернуть: 'Чоңойтуу',
  'Свернуть в окно': 'Терезеге кичирейтүү',
  // «Команда» variant A «Люди» (2026-07-27)
  // RU has three plural forms; ky does not inflect after a numeral, so all three map to one word.
  '{n} участник': '{n} катышуучу',
  '{n} участника': '{n} катышуучу',
  '{n} участников': '{n} катышуучу',
  '{n} преподаватель': '{n} мугалим',
  '{n} преподавателя': '{n} мугалим',
  '{n} преподавателей': '{n} мугалим',
  '{n} приглашение': '{n} чакыруу',
  '{n} приглашения': '{n} чакыруу',
  '{n} приглашений': '{n} чакыруу',
  '＋ Пригласить': '＋ Чакыруу',
  Управление: 'Башкаруу',
  Преподаватели: 'Мугалимдер',
  Приглашения: 'Чакыруулар',
  'на одного человека': 'бир адамга',
  Написать: 'Жазуу',
  'без @username — написать нельзя': '@username жок — жазуу мүмкүн эмес',
};
